import * as React from "react";
import "intersection-observer";
import { Action, IOWidget, mk_widget } from "widgets-for-react";
import { CMSState } from "../../../../cms/blocks/types.gen";
import { PublicSite_CustomPageData } from "../../../application.mod";

export interface FeaturedThemeItem {
  title: string
  link_url: string
  amount: string;
  image_id: number;
  image_src: string;
}

export type FeaturedThemesBlockProps<CustumBlockData, extra_images> = {
  label: string;
  title: string;
  intro: string;
  blocks: Array<FeaturedThemeItem>;
};

export let loopAnimFrameId = requestAnimationFrame(handleLoop);

export type FeaturedThemesBlockStyle = Partial<{}>;

export function FeaturedThemesBlock<customBlockData, extra_images>(
  props: FeaturedThemesBlockProps<customBlockData, extra_images>,
  options?: { style?: FeaturedThemesBlockStyle; key?: string }
): IOWidget<
  CMSState<customBlockData, extra_images, PublicSite_CustomPageData>,
  Action<CMSState<customBlockData, extra_images, never>>
> {
  return (cmsState: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: (_) => {
        return (
          <section className="block block--featured-themes block--themes">
            <div className="block__inner grid--block">
              {props.title && props.label && (
                <header className="block__header block__header--mobile">
                  {props.title && <h2 className="block__title typo--3xl">{props.title}</h2>}
                  {props.intro && <p className="block__intro" dangerouslySetInnerHTML={{__html: props.intro}}></p>}
                  {props.label && <span className="block__label typo--3xs">{props.label}</span>}
                </header>
              )}
              <div className="block__content items">
                <div className="items__visual fit-object">
                  {props.blocks.map((item, index) => (
                    <>
                      {item.image_id && (
                        <img
                          className={`items__image${index == 0 ? " items__image--active" : ""}`}
                          src={item.image_src}
                          alt={item.image_id.toString()}
                          data-key-id={`ft-${index}`}
                        />
                      )}
                    </>
                  ))}
                </div>
                <div className="block__wrap">
                  {props.title && props.label && (
                  <header className="block__header block__header--desktop">
                    {props.title && <h2 className="block__title typo--3xl">{props.title}</h2>}
                    {props.intro && <p className="block__intro" dangerouslySetInnerHTML={{__html: props.intro}}></p>}
                    {props.label && <span className="block__label typo--3xs">{props.label}</span>}
                  </header>
                  )}
                  <ul className="block__list">
                    {props.blocks.map((item, index) => (
                      <li className="block__item item">
                        <a className={`item__link${index == 0 && window.innerWidth >= 1024 ? " item__link--active" : ""}`}
                          href={item.link_url ? item.link_url : ""}
                          data-key-id={`ft-${index}`}
                          onMouseEnter={(e) => {
                            if (document.documentElement.querySelector(".items__image--active")) {
                              document.documentElement
                                .querySelector(".items__image--active")
                                .classList.remove("items__image--active");
                            }
                            if (document.documentElement.querySelector(".item__link--active")) {
                              document.documentElement
                                .querySelector(".item__link--active")
                                .classList.remove("item__link--active");
                            }
                            const el: HTMLElement = e.currentTarget as HTMLElement;
                            const elKey: string = el.getAttribute("data-key-id");
                            const imgEl: HTMLElement = document.documentElement.querySelector(
                              "img[data-key-id='" + elKey + "']"
                            );
                            imgEl.classList.add("items__image--active");
                            el.classList.add('item__link--hover')
                            // pause the timeout & add active class
                            cancelAnimationFrame(loopAnimFrameId);
                          }}
                          onMouseLeave={(e) => {
                            const el: HTMLElement = e.currentTarget as HTMLElement;
                            const elKey: string = el.getAttribute("data-key-id");
                            const imgEl: HTMLElement = document.documentElement.querySelector(
                              "img[data-key-id='" + elKey + "']"
                            );
                            el.classList.remove('item__link--hover')
                            el.classList.add('item__link--active')
                            // play the timeout & remove active class
                            loopAnimFrameId = requestAnimationFrame(handleLoop);
                          }}
                        >
                          <article className="item__inner">
                            <span className="item__line item__line--top" aria-hidden='true'></span>
                            <span className="item__line item__line--bottom" aria-hidden='true'></span>
                            <div className="item__header">
                              {item.title && (
                                <h3 className="item__title">
                                  {item.title}
                                </h3>
                              )}
                              {item.amount && (
                                <span className="item__label typo--3xs">
                                  {item.amount} {!isNaN(Number(item.amount)) ? Number(item.amount) > 1 ? "verhalen" : "verhaal" : ""}
                                </span>
                              )}
                            </div>
                          </article>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </section>
        );
      },
    });
}

let currentLoop: number = 0;

function handleLoop() {
  currentLoop = currentLoop + 1;
  const firstImg: HTMLElement = document.documentElement.querySelector("img[data-key-id='" + "ft-0" + "']");
  const secondImg: HTMLElement = document.documentElement.querySelector("img[data-key-id='" + "ft-1" + "']");
  const thirdImg: HTMLElement = document.documentElement.querySelector("img[data-key-id='" + "ft-2" + "']");

  const firstItem: HTMLElement = document.documentElement.querySelector("a[data-key-id='" + "ft-0" + "']");
  const secondItem: HTMLElement = document.documentElement.querySelector("a[data-key-id='" + "ft-1" + "']");
  const thirdItem: HTMLElement = document.documentElement.querySelector("a[data-key-id='" + "ft-2" + "']");

  if (currentLoop == 800 && window.innerWidth >= 1024 ) {
    if (firstImg != null && secondImg != null && thirdImg != null) {
      if (firstImg.classList.contains("items__image--active")) {
        firstImg.classList.remove("items__image--active");
        secondImg.classList.add("items__image--active");
      } else if (secondImg.classList.contains("items__image--active")) {
        secondImg.classList.remove("items__image--active");
        thirdImg.classList.add("items__image--active");
      } else if (thirdImg.classList.contains("items__image--active")) {
        thirdImg.classList.remove("items__image--active");
        firstImg.classList.add("items__image--active");
      }
    }

    if (firstItem != null && secondItem != null && thirdItem != null) {
      if (firstItem.classList.contains("item__link--active")) {
        firstItem.classList.remove("item__link--active");
        secondItem.classList.add("item__link--active");
      } else if (secondItem.classList.contains("item__link--active")) {
        secondItem.classList.remove("item__link--active");
        thirdItem.classList.add("item__link--active");
      } else if (thirdItem.classList.contains("item__link--active")) {
        thirdItem.classList.remove("item__link--active");
        firstItem.classList.add("item__link--active");
      }
    }
    currentLoop = 0;
  }

  loopAnimFrameId = requestAnimationFrame(handleLoop);
}
